import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'common/react/components/SvgIcon';

const ICON_BASE_CLASS = 'mc-player-stats-table__interchange-bench-value-icon';

/**
 * Component to render interchange bench reason label and optional icon.
 *
 * @param {object} props - Props.
 * @param {string} [props.rawReason] - Raw reason string (e.g. "INJURED", "OUT", "BLOOD").
 * @returns {JSX.Element|null} Component or null.
 */
export const BenchReasonLabel = ({ rawReason }) => {
    if (!rawReason) {
        return null;
    }

    const getBenchReasonMeta =
        PULSE?.app?.common?.interchange?.getBenchReasonMeta;

    if (typeof getBenchReasonMeta !== 'function') {
        return null;
    }

    const {
        shouldShowLabel,
        shouldHaveWrapper,
        reasonLabel,
        iconName,
        iconCssClass
    } = getBenchReasonMeta(rawReason, ICON_BASE_CLASS);

    // Return early if reasons shouldn't be rendered as a label
    if (!shouldShowLabel) {
        return null;
    }

    return (
        <div className="mc-player-stats-table__interchange-bench-meta">
            {shouldHaveWrapper ? (
                <div className="mc-player-stats-table__interchange-bench-value-wrapper">
                    <SvgIcon
                        className={`icon ${iconCssClass}`}
                        icon={iconName}
                    />
                    <p className="mc-player-stats-table__interchange-bench-value-text">
                        {reasonLabel}
                    </p>
                </div>
            ) : (
                <p className="mc-player-stats-table__interchange-bench-value-text">
                    {reasonLabel}
                </p>
            )}
        </div>
    );
};

BenchReasonLabel.propTypes = {
    rawReason: PropTypes.string
};
